import { getTelegramInviteLink } from './actionHelpers.js';

export interface InviteMessageOptions {
  inviterName?: string;
  locale?: 'ru' | 'en';
}

export function buildInviteMessage(options: InviteMessageOptions = {}): string {
  const { inviterName, locale = 'ru' } = options;
  if (locale === 'en') {
    return inviterName
      ? `${inviterName} invites you to a Tank Battle! 🎖 Tap to join.`
      : 'Join my Tank Battle! 🎖 Tap to play.';
  }
  return inviterName
    ? `${inviterName} приглашает вас в Tank Battle! 🎖 Откройте ссылку и нажмите «Принять вызов».`
    : 'Присоединяйся к Tank Battle! 🎖 Открой ссылку и нажми «Принять вызов».';
}

export function getTelegramSharePickerLink(battleId: string, text: string): string {
  const inviteUrl = getTelegramInviteLink(battleId);
  return `https://t.me/share/url?url=${encodeURIComponent(inviteUrl)}&text=${encodeURIComponent(text)}`;
}

/** Opens Telegram dialog to pick a contact/chat and send the invite. */
export function shareBattleInvite(
  battleId: string,
  options: InviteMessageOptions = {},
): 'shared' | 'copied' | 'unsupported' {
  const text = buildInviteMessage(options);
  const inviteUrl = getTelegramInviteLink(battleId);
  const tg = window.Telegram?.WebApp;

  if (tg?.shareURL) {
    tg.shareURL(inviteUrl, text);
    return 'shared';
  }

  if (tg?.openTelegramLink) {
    tg.openTelegramLink(getTelegramSharePickerLink(battleId, text));
    return 'shared';
  }

  if (navigator.clipboard?.writeText) {
    void navigator.clipboard.writeText(`${text}\n${inviteUrl}`);
    return 'copied';
  }

  return 'unsupported';
}

export function copyBattleInvite(
  battleId: string,
  options: InviteMessageOptions = {},
): Promise<boolean> {
  const text = buildInviteMessage(options);
  const inviteUrl = getTelegramInviteLink(battleId);
  if (!navigator.clipboard?.writeText) return Promise.resolve(false);
  return navigator.clipboard.writeText(`${text}\n${inviteUrl}`).then(() => true);
}
